import { useTranslation } from "react-i18next";
import {
  Container,
  Dialog,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Grid2 } from "@mui/material";
import { intro_fourth_texts } from "../../constants/intropageTexts";
import { intro_fifth_texts } from "../../constants/intropageTexts";

const ModalGreenBeanPlan = ({ onClose, onAdd }) => {
  const { t } = useTranslation();
  return (
    <Dialog fullScreen open={true} onClose={onClose} aria-labelledby="draggable-dialog-title" >

        <AppBar sx={{ position: "relative", boxShadow: 0, borderBottom: "1px solid #ccc", }} >
          <Toolbar sx={{ background: "#fff", }} >
            <IconButton edge="start" color="#9e9e9e" onClick={onClose} aria-label="close" >
              <ArrowBackIcon />
              <Typography sx={{ ml: 2, flex: 1, color: "#000000de", }} variant="h6" component="div" >
                {t('button.close')}
              </Typography>
            </IconButton>
          </Toolbar>
        </AppBar>

        {/* contentsB E */}
        <Box id="coffeeAnalysis" sx={{ backgroundColor: "#EFF2F4" }}>
          <Container sx={{ pt: 3, pb: 3, }} maxWidth="lg" >

            <Typography component="h3" variant="h5" sx={{marginLeft: "50px",  marginBottom: "32px", lineHeight: 2, fontWeight: "600" }} >
              {t('bwob.task3.title')}
            </Typography>

            <Grid2 container spacing={2}>
              {intro_fourth_texts.map((item, index) => (
                <Grid2 size={{ xs: 12, sm: 12, md: 4 }} key={index}>
                  {/* <InBox> */}
                  <Box sx={{ textAlign: "center" }}>
                    <img src={item.image} alt={item.imageLabel} />
                    <Typography variant="h5" sx={{ mt: 2 }}>
                      {t(item.i18nTitle)}
                    </Typography>
                    
                    <Typography component="div" variant="body1">
                      <div style={{whiteSpace: "pre-wrap", padding: '20px'}}>
                        {t(item.i18nDescription)}
                      </div>
                    </Typography>
                  </Box>
                  {/* </InBox> */}
                </Grid2>
              ))}
            </Grid2>

          </Container>
        </Box>

        {/* contentsC E */}
        <Box id="blockchainCoffee" sx={{}}>
          <Container sx={{ pt: 8, pb: 6, }} maxWidth="lg" >

            <Typography component="h3" variant="h5" sx={{marginLeft: "50px",  marginBottom: "32px", lineHeight: 2, fontWeight: "600" }} >
              {t('bwob.task4.title')}
            </Typography>

            <Grid2 container spacing={2}>
              {intro_fifth_texts.map((item, index) => (
                <Grid2 size={{ xs: 12, sm: 12, md: 4 }} key={index}>
                  {/* <InBox> */}
                  <Box sx={{ textAlign: "center" }}>
                    <img src={item.image} alt={item.imageLabel} />
                    <Typography variant="h5" sx={{ mt: 2 }}>
                      {t(item.i18nTitle)}
                    </Typography>

                    <Typography component="div" variant="body1">
                      <div style={{whiteSpace: "pre-wrap", padding: '20px'}}>
                        {t(item.i18nDescription)}
                      </div>
                    </Typography>
                  </Box>
                  {/* </InBox> */}
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>
        {/* contentsD E */}
    </Dialog>
  );
};

export default ModalGreenBeanPlan;
